export default {
    fund: [{
            "title": "某基金管理人拟募集成立一只合格投资者人数为180人的股权投资基金，基金可以选择的组织形式有（　　）。",
            "questions": "I. 有限责任公司<br>II. 股份有限公司<br>III. 有限合伙企业<br>IV. 契约型",
            "question": "A. II\nB. II、IV\nC. I、II、III、IV\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查合格投资者的人数限制。"
        },
        {
            "title": "在全国股转系统的挂牌流程中，公司决定进行股改的决策主体是公司的（　　）。",
            "question": "A. 监事会\nB. 股东会\nC. 董事会\nD. 经营层",
            "answer": "B",
            "explain": "本题考查股改的内容。"
        },
        {
            "title": "关于股权投资基金份额的转让，以下说法正确的是（　　）。",
            "questions": "I. 投资者转让股权投资基金份额，受让人必须为合格投资者<br>II. 投资者转让股权投资基金份额，基金份额受让后投资者人数不能超过法定限制<br>III. 投资者转让股权投资基金份额，可以在微信公众号刊登转让信息<br>IV. 投资者转让股权投资基金份额，必须在原投资者之间进行",
            "question": "A. I、III\nB. I、II、III\nC. I、II\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查股权投资基金份额的转让。"
        },
        {
            "title": "国家金融管理法关于非法吸收公众存款罪的规定，其构成要件之一是“向社会不特定对象吸收资金”。某股权投资基金的以下募集，不违反相关法规的是（　　）。",
            "question": "A. 向亲友或单位内部人员针对特定对象吸收资金\nB. 以吸收资金为目的，将社会人员吸收为单位内部人员，并向其吸收资金\nC. 未设置特定对象确定程序，通过推介会向社会公众吸收资金\nD. 在向亲友吸收资金的过程中，放任亲友向不特定对象吸收资金",
            "answer": "A",
            "explain": "本题考查非法吸收公众存款罪。"
        },
        {
            "title": "基金条款书常见的条款有（　　）。",
            "questions": "I. 投资范围条款<br>II. 利润分配条款<br>III. 缴款安排条款<br>IV. 运营成本条款",
            "question": "A. I、II、III\nB. II、III\nC. I、II\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查基金条款书的内容。"
        },
        {
            "title": "关于协议转让并购退出的步骤，以下表述错误的是（　　）。",
            "question": "A. 受让方尽职调查完成后，则转让方与受让方即可立即签署转让协议，约定股权转让事宜\nB. 受让方可按照股权转让意向书的约定，对目标公司进行尽职调查\nC. 转让方与受让方协商达成初步意向后，应当签署股权转让意向书\nD. 转让协议签署完成后，由目标公司、转让方、受让方共同配合完成股权交割与登记事宜",
            "answer": "A",
            "explain": "本题考查并购退出的程序。"
        }, {
            "title": "关于投资框架协议中排他性条款，以下表述正确的是（　　）。",
            "question": "A. 排他性条款要求股权投资基金在约定排他期内，不得投资其他同类业务公司的条款\nB. 排他性条款通常约定至少一年以上\nC. 排他性条款要求目标公司在约定排他期内不得与其他投资机构接触的条款\nD. 目标公司在签署排他性条款协议后，排他期内如果与其他投资方接触，则必须在接触后10个工作日内以书面形式通知投资方",
            "answer": "C",
            "explain": "本题考查排他性条款。A选项说法错误，排他性条款要求目标企业现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。B选项说法错误，排他性条款的排他期由双方约定，通常为几个月。"
        },
        {
            "title": "股权投资基金管理人应当于每年度结束之日起20个工作日内，更新基本信息，主要内容包括（　　）。",
            "questions": "I. 管理人、股东或合伙人情况<br>II. 高级管理人员及其他从业人员情况<br>III. 所管理的股权投资基金情况<br>IV. 经审计的年度财务报告",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、IV",
            "answer": "B",
            "explain": "本题考查信息披露内容。股权投资基金管理人应当在每年度结束之日起20个工作日内,更新私募基金管理人、股东或合伙人(I项)、高级管理人员及其他从业人员(II项)、所管理的私募基金(III项)等基本信息。IV项不符合,股权投资基金管理人应当于每个会计年度结束后的4个月内,向中国证券投资基金业协会报送经审计的年度财务报告。"
        },
        {
            "title": "某股权投资基金拟投资从事无人驾驶项目的目标公司，预计5年退出时的股权价值为100亿元，目标收益率为40%，使用创业投资估值法计算目标公司当前股权价值为（　　）亿元。",
            "question": "A. 5.3\nB. 18.59\nC. 33.33\nD. 106",
            "answer": "B",
            "explain": "本题考查创业投资估值法的计算。创业投资估值法估值的公式为:当前股权价值=退出时的股权价值/(1+目标收益率)^n，由题干可知，退出时的股权价值为100亿元，目标收益率为40%，代入公式:当前股权价值=100/(1+40%)^5=18.59(亿元)。"
        },
        {
            "title": "基金管理人进行登记并开展基金管理业务应满足一定的基本要求，以下说法错误的是（　　）。",
            "question": "A. 基金管理人只能为依法设立的公司或合伙企业，自然人不能登记为基金管理人\nB. 兼营民间借贷、小额理财、房地产开发等业务的机构申请成为私募基金管理机构时，由于业务和私募基金属性相冲突，中国证券投资基金业协会对此类存在冲突业务的机构不予登记\nC. 基金管理人从业人员人数应当和其内部机构的设置以及内控制度相匹配，并且应当具备相应数量的专职高管人员\nD. 以私募基金管理业务为主营业务的基金管理人，可以同时兼并其他类型的基金管理业务",
            "answer": "D",
            "explain": "本题考查基金管理人登记与备案的基本要求。"
        },
        {
            "title": "股权投资基金A拟对科技公司甲进行投资前的尽职调查工作，在尽职调查中A基金发现甲公司管理技术人员作为乙公司联合创始人同时持有乙公司的股权，自己公司的业务是基于与甲公司的同一核心技术在不同领域的运用。同时，甲公司的该高管还持有丙餐厅的股权，由该高管的妻子打理，有关竞业禁止考虑，以下表述恰当的是（　　）。",
            "questions": "I. A基金要求该高管在投资交割之前签署相关竞业禁止协议<br>II. 鉴于尽调结果较为复杂，A基金引入律所，讨论、谈判并撰写竞业禁止的相关协议条款<br>III. 该高管表示自己并不是乙公司的主要股东，且公司已不在实际运营状态，所以A基金不用将乙公司列入竞业禁止的考虑范畴<br>IV. 鉴于丙餐厅与科技公司甲无业务往来，也无任何形式的竞争关系，A基金决定不将丙餐厅列入竞业禁止的考虑范畴",
            "question": "A. I、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查竞业禁止条款内容。"
        },
        {
            "title": "某非金融机构公司法人主体，拟参与某上市公司的非公开发行，其可采取的参与方式包括（　　）。",
            "questions": "I. 通过有限合伙型基金间接参与<br>II. 通过公司型基金间接参与<br>III. 通过资产管理计划间接参与<br>IV. 直接参与",
            "question": "A. I、IV\nB. I、II、III、IV\nC. I、II、III\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查非金融机构投资。I、II项说法正确，对于上市公司的非公开发行，非金融机构企业可以通过投资于公司型基金、合伙型基金和资产管理计划，进行间接投资。IV项说法错误，非金融机构不能从事直接投资。"
        }, {
            "title": "在证券交易所进行证券交易时，对一段时间内接受的买卖申报一次性撮合的价格形成机制是（　　）。",
            "question": "A. 大宗交易\nB. 集合竞价\nC. 连续竞价\nD. 协议转让",
            "answer": "B",
            "explain": "本题考查竞价交易机制的内容。集合竞价是指对一段时间内接受的买卖申报一次性撮合的竞价方式。"
        },
        {
            "title": "信托(契约)型基金是通过订立信托契约的形式设立的股权投资基金，关于信托(契约)型基金，表述错误的是（　　）。",
            "question": "A. 基金的参与主体包括基金投资者、基金管理人及基金托管人\nB. 基金管理人依据法律法规和基金合同负责基金的经营和管理操作\nC. 基金是独立法人基金\nD. 投资者通过购买基金份额享有投资收益",
            "answer": "C",
            "explain": "本题考查信托(契约)型基金的内容。信托(契约)型基金不具有独立的法人地位。"
        },
        {
            "title": "关于科技型中小微企业的特征，以下表述正确的是（　　）。",
            "question": "A. 大多数已建立规范的公司治理架构\nB. 创业成功概率较高\nC. 一般固定资产比例占比较高\nD. 早期发展阶段可能会需要股权融资",
            "answer": "D",
            "explain": "本题考查中小微企业的融资需求特征。中小微企业的融资需求呈现阶段性特征，在早期发展阶段可能需要较小规模、较大比例的股权投资，中后期发展阶段则可能以可转换优先股、可转换债等准股权方式融资。"
        },
        {
            "title": "股权投资基金管理人履行重大事项信息报送更新义务中，下述不属于重大事项信息的是（　　）。",
            "question": "A. 投资者数量超过法律法规规定\nB. 基金托管人发生变更\nC. 基金管理人注册地发生变更\nD. 基金发生清盘或清算",
            "answer": "C",
            "explain": "本题考查登记与备案的内容。基金管理人应当在5个工作日内向基金业协会报告投资者数量超过法律法规规定、基金托管人变更、基金发生清盘或清算等重大事项。"
        },
        {
            "title": "基金管理人委托基金销售机构募集股权投资基金时，需书面签订销售协议，并将权利义务划分及其他涉及投资者利益的部分作为基金合同的附件。如基金销售协议与作为基金合同附件的关于基金销售的内容不一致的，（　　）。",
            "question": "A. 以基金合同附件为准\nB. 通过合同双方协商决定\nC. 以基金销售协议为准\nD. 以可行的实际操作为准",
            "answer": "A",
            "explain": "本题考查委托募集的相关规定。若基金销售协议与作为基金合同附件的关于基金销售的内容不一致的，以基金合同附件为准。"
        },
        {
            "title": "关于被投资企业的项目跟踪与监控，下列表述错误的是（　　）。",
            "question": "A. 协助建立规范的财务管理体系的目标是改善企业财务状况\nB. 投资机构通常会跟踪被投资企业重大合同等业务经营信息\nC. 不同类型的被投资企业适用的经营指标不同\nD. 投资机构通常要求被投资企业定期提供财务报表和业绩报告",
            "answer": "A",
            "explain": "本题考查股权投资基金的投资后管理。协助建立规范的财务管理体系的目标是帮助被投资企业建立起以“规范管理、风险控制和全面预算”为基本准则的现代财务管理体系。"
        }, {
            "title": "违反国家金融管理法律规定，向社会公众（包括单位和个人）吸收资金的行为，是“非法吸收公众存款或者变相吸收公众存款”条件的是（　　）。",
            "questions": "I. 未经有关部门依法批准或者借用合法经营的形式吸收资金<br>II. 通过媒体、推介会、传单、手机短信等途径向社会公开宣传<br>III. 承诺在一定期限内以货币、实物、股权等方式还本付息或者给付回报<br>IV. 未向社会公开宣传，在亲友或者单位内部针对特定对象吸收资金",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、III、IV\nD. I、III、IV",
            "answer": "A",
            "explain": "本题考查非法吸收公众存款罪。"
        },
        {
            "title": "关于信息披露报告的有关表述，以下错误的是（　　）。",
            "question": "A. 股权基金管理人应当按照规定通过中国证券投资基金业协会制定的私募基金信息披露备份平台进行信息披露文件备份\nB. 已在私募基金信息披露备份平台备份的报告可供基金管理人自行下载\nC. 股权投资基金管理人应保证信息披露报告披露的信息不存在任何虚假记载、误导性陈述或者重大遗漏\nD. 在私募基金信息披露备份平台备份的信息披露报告，面向社会公众和基金投资者公开查询",
            "answer": "D",
            "explain": "本题考查基金信息披露的相关规定。"
        },
        {
            "title": "投资机构D持有G公司25%比例的股权并享有常见的股东权利，其余股权由创始人团队持有。现创始人团队欲向新投资机构T出售其持有的5%股权，如果投资机构D也想向T出售其持有的部分股权，则可以选择行使（　　）。",
            "question": "A. 反摊薄条款\nB. 回售权条款\nC. 随售权条款\nD. 第一拒绝权条款",
            "answer": "C",
            "explain": "本题考查随售权条款。"
        },
        {
            "title": "股权投资基金与目标公司的投资协议中通常包括营业禁止条款，条款内容一般涉及（　　）。",
            "questions": "I. 竞业禁止关键人<br>II. 竞业含义与范围<br>III. 竞业禁止期<br>IV. 投资人竞业禁止",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、III",
            "answer": "C",
            "explain": "本题考查竞业禁止条款的内容。"
        },
        {
            "title": "某股权投资基金和目标公司在投资协议中约定，如基金欲将所持目标公司股份转让给第三方购买人，购买人拟购买目标公司100%的股份，那么目标公司的其他所有股东需按和该基金相同的价格与条件出售其在目标公司的全部权益。上述约定通常被称为（　　）。",
            "question": "A. 随售权条款\nB. 完全释轮条款\nC. 拖售权条款\nD. 回售权条款",
            "answer": "C",
            "explain": "本题考查拖售权条款。"
        },
        {
            "title": "关于投资者协议中的拖售权条款，以下表述错误的是（　　）。",
            "question": "A. 相对随售权，拖售权赋予股权投资基金更大的权利\nB. 拖售权是股权投资基金强行进入其他股东与第三方的交易，交易价格以其他股东与第三方协商确定的价格为准\nC. 在多数情形下，拖售权条款会被投资企业创始股东拒绝，或者对拖售权行使设置一定的条件\nD. 拖售权设计的初衷是保障股权投资基金通过被投企业被第三方机构并购成功实现项目退出的权利",
            "answer": "B",
            "explain": "本题考查拖售权与随售权的区别。"
        }, {
            "title": "某有限责任公司型股权投资基金近期拟完成二次募集关账，其中新投资人甲拟出资500万元，同时原股东乙拟转让400万元给外部投资人丙，同时减少出资100万元。以下表述错误的是（　　）。",
            "question": "A. 工商变更完成后，基金规模增加400万元\nB. 乙向丙转让需要经过一定比例其他股东同意\nC. 本次增资或减资决议需要经过代表1/2以上表决权的股东通过\nD. 甲出资将增加公司注册资本金",
            "answer": "C",
            "explain": "本题考查公司型股权投资基金的增资、减资和股份转让。有限责任公司型股权投资基金作出增资或者减资决议，必须经代表2/3以上表决权的股东通过。"
        },
        {
            "title": "股权投资基金行业自律组织的作用包括（　　）。",
            "questions": "I. 提供行业服务，促进行业交流和创新，提升行业职业素质，提高行业竞争力<br>II. 发挥行业与政府间的桥梁与纽带作用，维护行业合法权益，促进公众对行业的理解<br>III. 履行行业自律管理，促进行业合规经营，对违法违规的市场主体采取责令改正、监管谈话、公开谴责等惩罚措施<br>IV. 促进会员忠实履行受托义务和社会责任，推动行业持续稳定健康发展",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查协会的作用。对违法违规的市场主体采取责令改正、监管谈话、出具警示函、公开谴责等惩罚措施属于政府监管机构的职权，故此项不属于股权投资基金行业自律组织的作用。"
        },
        {
            "title": "基金托管的服务内容不包括（　　）。",
            "question": "A. 基金估值\nB. 账户管理\nC. 会计核算\nD. 份额登记",
            "answer": "D",
            "explain": "本题考查基金托管人的服务。基金托管人的服务包括：资产保管；账户管理（排除B）；"
        },
        {
            "title": "关于股权投资基金管理人及其受托的基金服务机构的责任分担，说法中错误的是（　　）。",
            "question": "A. 基金管理人与基金服务机构应在双方签订的服务协议中对双方之间的责任分配进行约定\nB. 基金服务机构在开展业务的过程中，因技术故障、操作错误原因给基金财产造成的损失，应当由基金管理人先行承担赔偿责任，基金管理人再向基金服务机构追偿\nC. 基金服务机构在开展业务的过程中，因违法违规、违反服务协议给基金财产造成的损失，应当由基金服务机构直接承担赔偿责任\nD. 基金管理人委托基金服务机构提供基金服务的，该管理人依法应当承担的责任不因委托而免除",
            "answer": "C",
            "explain": "本题考查基金管理人及其受托的基金服务机构的责任分担。基金服务机构在开展业务的过程中，因违法违规、违反服务协议给基金财产造成的损失，应当由基金服务机构直接承担赔偿责任。"
        },
        {
            "title": "关于股权投资基金收益分配中的门槛收益，以下说法正确的是（　　）。",
            "question": "A. 基金管理人应保证投资人获得门槛收益\nB. 股权投资基金均应在合同中约定门槛收益率\nC. 股权投资基金应先向管理人支付业绩报酬，再向投资人分配门槛收益\nD. 投资人收回全部本金后，再进行门槛收益的分配",
            "answer": "D",
            "explain": "本题考查基金收益分配的流程。股权投资基金的分配通常采用瀑布式的收益分配体系：项目投资退出的资金先返还基金投资者，当投资者收回全部投资本金后，再按照约定的门槛收益率（如有）向基金投资者分配门槛收益。"
        },
        {
            "title": "关于股权投资基金的运营行为，不符合法律法规规定的是（　　）。",
            "question": "A. 向投资者承诺在未未来某个时间点以事先确定的价格回购基金份额，从而保证投资者实现某一最低收益率\nB. 向投资者说明基金收益与风险的匹配情况\nC. 向投资者说明基金承担的主要费用及费率\nD. 向投资者宣传基金过去六个月的整体历史投资回报率",
            "answer": "A",
            "explain": "本题考查从事股权投资基金募集的禁止性行为。股权投资基金管理人、股权投资基金销售机构及其从业人员从事股权投资基金募集业务，不得以任何方式承诺投资者资金不受损失，或者以任何方式承诺投资者最低收益。"
        }, {
            "title": "关于股权投资基金的募集方式，下列表述正确的是（　　）。",
            "question": "A. 基金管理人只有采取自行募集的方式才能向合格投资者之外的单位或个人募集资金\nB. 基金管理人可以委托具有合格基金托管资质的第三方机构向合格投资者募集资金\nC. 股权投资基金的合格销售资质指应获得中国证监会基金销售业务资格且成为中国证券投资基金业协会会员\nD. 基金管理人签署委托募集的书面协议后，基金代销机构可自行决定募集对象并向合格投资者之外的单位或个人募集资金",
            "answer": "C",
            "explain": "本题考查股权投资基金的募集方式。"
        },
        {
            "title": "中国证监会及其派出机构对股权投资基金当事人的违法违规行为进行处理，以下不属于行政监管措施的是（　　）。",
            "question": "A. 公开谴责\nB. 注销相关人员的基金从业资格\nC. 责令改正\nD. 监管谈话",
            "answer": "B",
            "explain": "本题考查中国证监会的行政监管措施。"
        },
        {
            "title": "以下不属于对目标公司业务尽职调查主要内容的是（　　）。",
            "question": "A. 融资运用\nB. 纳税分析\nC. 管理团队\nD. 发展战略",
            "answer": "B",
            "explain": "本题考查业务尽职调查的内容。"
        },
        {
            "title": "关于创业投资基金的运作特点，表述错误的是（　　）。",
            "question": "A. 投资对象主要是未上市成长性创业企业\nB. 投资方式以参股性投资为主\nC. 投资收益来源于所投资企业的价值创造带来的股权增值\nD. 经常借用杠杆进行投资",
            "answer": "D",
            "explain": "本题考查创业投资基金的特点。"
        },
        {
            "title": "有限合伙型股权投资基金的纳税义务人是（　　）。",
            "question": "A. 全体合伙人\nB. 合伙企业\nC. 普通合伙人\nD. 有限合伙人",
            "answer": "A",
            "explain": "本题考查合伙型基金的所得税缴纳。"
        },
        {
            "title": "甲股权投资基金投资了某医院管理公司X，双方签署了包含保密条款的投资协议，甲基金可能违反保密义务的行为是（　　）。",
            "question": "A. 在向基金投资者定期披露的基金报告中描述X项目投资金额及项目基本情况\nB. 向基金审计师提供了X项目的年度财务报表\nC. 向基金现有投资组合中同行业项目的高管咨询确认X项目扩张规划的合理性\nD. 经X项目书面允许向媒体披露了其最新纳入托管的医院名称",
            "answer": "C",
            "explain": "本题考查保密条款的保密内容。"
        }, {
            "title": "除中国证监会作为股权投资基金法定监管机构外，行使对股权投资基金的管理职权的政府部门和司法机关有（　　）。",
            "questions": "I. 工商行政管理部门和国家税务总局<br>II. 财政部和国家发展改革委<br>III. 商务部和国家外汇局<br>IV. 国务院国资委和地方国资委",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查股权投资基金其他法定监管的内容。"
        },
        {
            "title": "关于股权投资基金监管的基本原则，以下表述正确的是（　　）。",
            "questions": "I. 监管机构依据法律程序行使监管权限和职责，体现了高效监管原则<br>II. 对于违法行为，规定明确的法律责任和制裁手段，体现了依法监管的原则<br>III. 监管机构依据对市场主体进行制裁，体现了依法监管的原则<br>IV. 赋予监管机构合理的监管权限和职责，体现了高效监管的原则",
            "question": "A. II、III\nB. III、IV\nC. II、IV\nD. I、III",
            "answer": "B",
            "explain": "本题考查股权投资基金监管的基本原则。"
        },
        {
            "title": "关于股权投资基金的监管机构，下列表述正确的是（　　）。",
            "question": "A. 中国证监会及中国证券投资基金业协会是我国股权投资基金的监管机构\nB. 作为我国股权投资基金的监管机构之一，中国证券投资基金业协会负责依法对股权投资基金业务活动实施监督管理\nC. 作为我国股权投资基金的监管机构之一，证券交易所负责依法对股权投资基金投资活动实施监督管理\nD. 中国证监会派出机构属于我国股权投资基金的监管机构",
            "answer": "D",
            "explain": "本题考查股权投资基金的监管机构。"
        },
        {
            "title": "关于股权投资基金行业自律与政府监管，表述错误的是（　　）。",
            "question": "A. 行业自律组织在政府监管机构和市场主体之间起着桥梁和纽带作用\nB. 行业自律组织制定的章程、业务规则对政府监管起约束作用\nC. 行业自律是对政府监管的积极补充\nD. 目的一致，都是确保国家有关股权投资基金的相关法律、法规、规章和政策得到贯彻执行，保护投资者的合法权益",
            "answer": "B",
            "explain": "本题考查股权投资基金行业自律与政府监管的关系。"
        },
        {
            "title": "股权投资母基金A在股权投资基金B的存续期第3年，从基金B的投资人C处，以C持有基金B份额按公允价值估值，购买C持有基金B的全部份额。针对该交易，以下说法错误的是（　　）。",
            "question": "A. 该交易描述的是母基金二级投资业务中的购买存续基金份额及后续出资额\nB. 因缺乏流动性，母基金A可以一定折扣购买C持有的基金B的份额\nC. 通常情况下，该交易相对于母基金A在基金B设立时直接投资基金B，能更快回收投资\nD. 母基金A在该交易中只需考察基金B所持有投资组合公司的价值",
            "answer": "D",
            "explain": "本题考查股权投资母基金的二级投资业务。"
        },
        {
            "title": "股权投资基金管理人，股权投资基金托管人应当在基金合同中约定（　　）以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者提供虚假信息。",
            "questions": "I. 基金投资情况<br>II. 投资收益分配<br>III. 基金承担的费用<br>IV. 业绩报酬",
            "question": "A. I、III\nB. I、II、IV\nC. III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查需要向投资者披露的信息。"
        }, {
            "title": "股权投资基金为被投资企业提供的增值服务，通常不包括（　　）。",
            "question": "A. 上市辅导及并购整理\nB. 主导生产工艺流程的改进\nC. 完善公司治理结构\nD. 规范财务管理系统",
            "answer": "B",
            "explain": "本题考查增值服务的主要内容。"
        },
        {
            "title": "基金服务机构在开展业务过程中，因违法违规、违反服务协议等原因给基金财产造成的损失，处理方式应为（　　）。",
            "question": "A. 服务机构承担全部责任\nB. 服务机构承担全责并进行赔偿\nC. 基金管理人承担全责并进行赔偿\nD. 基金管理人先行承担赔偿责任，再按服务协议约定与服务机构进行责任分配与损失追偿",
            "answer": "D",
            "explain": "本题考查服务业务管理。"
        },
        {
            "title": "关于股权投资基金的组织形式，表述错误的是（　　）。",
            "question": "A. 合伙型基金采用普通合伙企业的形式\nB. 公司型、合伙型、信托（契约）型基金的税负不一致\nC. 广义信托（契约）型股权投资基金，通常借信托计划、资产管理计划、信托（契约）型基金等多种形式\nD. 股权投资基金组织形式有公司型、合伙型和信托（契约）型",
            "answer": "A",
            "explain": "本题考查股权投资基金的组织形式。"
        },
        {
            "title": "股权投资基金A针对目标公司B的投资流程已进入投资交割环节，以下表述错误的是（　　）。",
            "question": "A. B公司和A基金在投资协议上约定将投资款转入B公司股东C的账户而不是B公司的账户\nB. A基金没有办理托管，在其内部决策批准后按照投资协议的要求将投资款直接转入B公司的账户\nC. 投资交割作为股权投资基金流程中的一环，需待A基金与B公司的投资协议正式生效后进行\nD. B公司收到A基金转入的投资款后出具了加盖公司公章的收据和认可股权变更的说明，这标志了投资交割的完成",
            "answer": "D",
            "explain": "本题考查股权投资的一般流程。"
        },
        {
            "title": "基金托管的基本原则有（　　）。",
            "questions": "I. 合规性原则<br>II. 安全性原则<br>III. 易得性原则<br>IV. 独立性原则<br>V. 保密性原则",
            "question": "A. I、II、III、IV\nB. I、II、IV、V\nC. I、II、III、V\nD. I、II、III、IV、V",
            "answer": "B",
            "explain": "本题考查基金托管的基本原则。"
        },
        {
            "title": "关于股权回售条款，企业创始人需要关注（　　）。",
            "questions": "I. 回售时间<br>II. 是否分期回售<br>III. 触发条件<br>IV. 回售价格",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、II、IV\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查回售权条款。"
        }, {
            "title": "有关回售权条款，下列表述正确的是（　　）。",
            "question": "A. 回售权的执行涉及出售方拥有的全部股权，出售方不可以选择仅将持有的部分股权出售\nB. 触发条件具备后，投资人可以要求目标公司创始股东按照约定的价格履行相关义务，创始股东不可能定其他相关利益方\nC. 满足协议约定的特定触发条件时，股权投资基金可依据回售权条款将其持有的相关目标公司股权以约定的价格出售给目标公司\nD. 同售权是指满足协议约定的特定触发条件时，股权投资基金有权要求公司创始股东以约定的价格出售部分股权给基金",
            "answer": "C",
            "explain": "本题考查回售权条款的定义。"
        },
        {
            "title": "某投资基金管理人同时管理A、B两只基金，A基金清算时，B基金拟购买A基金持有的大部分资产，但管理人未向B基金投资者披露该交易，下列表述正确的是（　　）。",
            "questions": "I. 中国证券投资基金业协会可要求管理人限期向投资者披露该交易<br>II. 中国证券投资基金业协会可要求管理人限期向其详细报告该交易<br>III. 中国证券投资基金业协会可要求管理人停止该交易<br>IV. 中国证券投资基金业协会可以直接对管理人采取加入黑名单的纪律处分",
            "question": "A. I、III\nB. III、IV\nC. I、II\nD. II、IV",
            "answer": "C",
            "explain": "本题考查信息披露的自律管理措施。"
        },
        {
            "title": "某公司注册资本100万元，某投资人拟投资100万元人民币，占该公司2%的股份，公司投资后估值为（　　）。",
            "question": "A. 500万元\nB. 5000万元\nC. 2000万元\nD. 200万元",
            "answer": "B",
            "explain": "本题考查公司的估值。"
        },
        {
            "title": "以下关于非上市股权转让，表述正确的是（　　）。",
            "question": "A. 股权转让协议签署后，目标公司应向受让方签发出资证明书，并相应修改公司章程和股东名册\nB. 非上市股权转让原则上均需通过产权市场公开发行\nC. 有限责任公司的外部转让一般需要经其他股东过三分之二同意，且其他股东放弃优先购买权\nD. 对目标公司的尽职调查通常由受让方自行完成",
            "answer": "A",
            "explain": "本题考查协议转让退出的内容。"
        },
        {
            "title": "关于相对估值法与折现现金流估值法的区别，下列表述正确的是（　　）。",
            "question": "A. 相对估值法以完整的财务信息为基础\nB. 折现现金流估值法更新反映市场目前的状况\nC. 相对估值法主观因素较少\nD. 折现现金流估值法的假设较少",
            "answer": "C",
            "explain": "本题考查相对估值法与折现现金流估值法的区别。"
        },
        {
            "title": "关于股权投资基金所投资项目的上市转让退出，以下表述错误的是（　　）。",
            "question": "A. 从退出成本的角度来看，首发上市需要支付给承销商及其他市场服务机构相对较高的费用\nB. 从退出收益的角度来看，上市转让退出的收益一般要比挂牌转让退出的收益高\nC. 从退出效率的角度来看，首次公开发行股票并上市不存在限售期\nD. 从退出风险的角度来看，首发上市后到将所持上市企业的股票卖出期间的股票价格波动会影响到股权投资基金的收益",
            "answer": "C",
            "explain": "本题考查上市转让退出的特点。"
        }, {
            "title": "股权投资基金设立的组织形式主要分为公司型、合伙型和信托（契约）型，以下（　　）因素影响基金设立时的组织形式选择。",
            "questions": "I. 投资人税收政策<br>II. 信息披露要求<br>III. 投资决策机制<br>IV. 收益分配机制<br>V. 募集人数",
            "question": "A. I、III、IV、V\nB. I、III、IV\nC. I、II、III、V\nD. II、IV、V",
            "answer": "A",
            "explain": "本题考查股权投资基金组织形式的选择。"
        },
        {
            "title": "基金管理人应当建立科学严密的风险评估体系，下列表述错误的是（　　）。",
            "question": "A. 独立的风险业绩评估小组为基金管理人提供风险评估报告，但不作为决策参考依据\nB. 基金管理人风险评估系统可以对基金运作情况发出预警和报警讯号\nC. 基金管理人要及时识别，系统分析经营活动与内部控制目标相关的风险，合理确定风险应对策略\nD. 对公司内外部风险进行识别、评估和分析，及时防范和化解风险",
            "answer": "A",
            "explain": "本题考查风险评估的内容。"
        },
        {
            "title": "某股权投资基金拟投资A公司5000万元。A公司当年的财务数据为：净利润9000万元，净债务3000万元，利息200万元，所得税税率为25%，按照企业价值/息税前利润倍数法进行投后估值时，使用5倍倍数，则该基金在完成本次投资后在A公司的股权占比为（　　）。",
            "question": "A. 8.62%\nB. 8.73%\nC. 8.20%\nD. 9.22%",
            "answer": "A",
            "explain": "本题考查企业价值/息税前利润倍数法。"
        },
        {
            "title": "基金管理人委托基金服务机构提供基金业务服务的，（　　）。",
            "question": "A. 基金管理人应依法承担的责任完全转移给基金服务机构\nB. 基金管理人应依法承担的责任部分转移给基金服务机构\nC. 基金管理人应依法承担的责任不因委托而免除\nD. 基金管理人将不承担任何责任",
            "answer": "C",
            "explain": "本题考查基金服务业务中基金管理人应承担的责任。"
        },
        {
            "title": "关于股权投资基金管理人向中国证券投资基金业协会报送相关信息的表述，以下错误的是（　　）。",
            "question": "A. 股权投资基金管理人应当及时填报并定期更新管理人及其从业人员的有关信息\nB. 股权投资基金管理人应当每季度按时报送经审计的财务报告和投资运作基本情况\nC. 发生重大事项，应当在10个工作日内向中国证券投资基金业协会报告\nD. 管理人应当披露所管理股权投资基金的投资运作情况和杠杆运用情况",
            "answer": "B",
            "explain": "本题考查向中国证券投资基金业协会报送相关信息。"
        },
        {
            "title": "下列关于公司型股权投资基金应纳税所得额的说法中，正确的是（　　）。",
            "question": "A. 公司每一纳税年度的收入总额，减除不征税收入、免税收入、各类政府补贴、各项扣除以及允许弥补的以前年度亏损的余额，为应纳税所得额\nB. 公司每一纳税年度的收入总额，减除不征税收入、免税收入、各项扣除后的余额，为应纳税所得额\nC. 公司每一纳税年度的收入总额，减除不征税收入、免税收入、各项扣除以及允许弥补的以前年度亏损后的余额，为应纳税所得额\nD. 公司每一纳税年度的收入总额，减除不征税收入、免税收入、各项扣除以及允许弥补的上一年度亏损后的余额，为应纳税所得额",
            "answer": "C",
            "explain": "本题考查应纳税所得额的内容。"
        }, {
            "title": "股权投资基金常用的估值方法包括（　　）。",
            "questions": "I. 重置成本法<br>II. 近期交易价格法<br>III. 乘数法<br>IV. 贝叶斯估计法",
            "question": "A. II、III\nB. I、II、III、IV\nC. I、III\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查股权投资基金的估值方法。"
        },
        {
            "title": "某证券公司宣传资料中表示可为股权投资基金提供以下服务，其中不属于基金服务团队提供的服务是（　　）。",
            "question": "A. 资产估值和会计核算\nB. 开立和管理资产托管账户\nC. 信息系统运营维护\nD. 投资人名册登记和权益登记",
            "answer": "B",
            "explain": "本题考查基金服务业务的内容。"
        },
        {
            "title": "甲基金销售机构应当具备的资质条件是（　　）。",
            "question": "A. 在中国证券投资基金业协会取得基金销售业务资格\nB. 在中国证券投资基金业协会取得基金销售业务资格，并成为中国证券投资基金业协会的会员\nC. 在中国证监会取得基金销售业务资格，并成为中国证券投资基金业协会会员\nD. 在中国证监会取得基金销售业务资格",
            "answer": "C",
            "explain": "本题考查销售机构应当具备的资质条件。"
        },
        {
            "title": "与企业价值正相关的企业经营指标包括（　　）。",
            "questions": "I. 收入<br>II. 利润<br>III. 增长率<br>IV. 负债率",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查经营指标。"
        },
        {
            "title": "下列哪类情形不属于我国刑法规定的“以非法占有为目的的，使用诈骗方法非法集资”（　　）。",
            "question": "A. 拒不交代资金去向，逃避返还现金的\nB. 将集资款用于投资股市等，并且用其中盈利来给投资人兑付本息\nC. 肆意挥霍集资款，致使集资款不能返还\nD. 将集资款用于违法犯罪活动",
            "answer": "B",
            "explain": "本题考查“以非法占有为目的”的情形。"
        },
        {
            "title": "某投资者于2015年T日投资某基金200万元，T日该基金份额净值为1.00，截至2017年末基金份额净值为1.20，该投资者已获得现金分红60万元，其已分配收益倍数为（　　）。",
            "question": "A. 0.2\nB. 1.5\nC. 0.3\nD. 0.5",
            "answer": "C",
            "explain": "本题考查已分配收益倍数的计算。"
        }, {
            "title": "对于（　　）的企业，尽职调查的考察包含管理团队、资产质量、融资结构、融资运用、发展战略以及风险分析等。",
            "question": "A. 创业阶段\nB. 成长阶段\nC. 成熟阶段\nD. 并购阶段",
            "answer": "C",
            "explain": "本题考查业务尽职调查。不同企业类型及所处发展阶段的目标公司调查内容的侧重点也不同。"
        },
        {
            "title": "我国公司型基金的法律依据为（　　），基金按照公司章程来运营。",
            "question": "A. 《公司法》\nB. 《证券投资基金法》\nC. 《证券法》\nD. 《合伙公司法》",
            "answer": "A",
            "explain": "本题考查公司型基金合同。"
        },
        {
            "title": "股权投资基金管理人应建立健全外包业务控制，并至少（　　）开展一次全面的外包业务风险评估。",
            "question": "A. 每年\nB. 每月\nC. 每季度\nD. 每半年",
            "answer": "A",
            "explain": "本题考查管理人内部控制的主要控制活动要求。"
        },
        {
            "title": "下列关于完全重置成本法的说法中，正确的是（　　）。",
            "questions": "I. 重置成本法的客观因素较大，且历史成本与未来价值并无必然联系，因此主要作为一种辅助方法<br>II. 完全重置成本是指在现时条件下重新购置一项全新状态的资产所需的全部成本<br>III. 重置成本法是用待评估资产的重置全价减去其各种贬值后的差额作为该项资产价值的评估方法<br>IV. 待评估资产价值=重置全价×综合成新率",
            "question": "A. I、II、IV\nB. I、II、III\nC. I、II、III、IV\nD. II、III、IV",
            "answer": "D",
            "explain": "本题考查重置成本法。"
        },
        {
            "title": "下列关于投资者投资股权投资基金时应履行义务的说法中，错误的是（　　）。",
            "question": "A. 确保自身符合合格投资者条件\nB. 对自身资产或收入情况应作如实承诺，如提供虚假承诺文件，应承担相应责任\nC. 如实填写风险识别能力和承担能力问卷\nD. 如自身不符合合格投资者条件，可以购买以私募基金份额或其收益权为投资标的金融产品",
            "answer": "D",
            "explain": "本题考查自行募集和委托募集。"
        },
        {
            "title": "关于政府引导基金的投资方向，以下表述正确的是（　　）。",
            "question": "A. 具有一定的导向性，通常投资于创业投资基金以引导社会资金进入早期创业投资领域\nB. 具有一定的导向性，投资方向限定为公共事业和基础设施投资\nC. 不具有导向性，采取纯市场化方式运作，但是由政府财政出资设立\nD. 一般不具有导向性，往往通过直接对创业企业进行投资获得较高投资收益",
            "answer": "A",
            "explain": "本题考查股权投资母基金。"
        }, {
            "title": "下列关于我国股权投资基金的募集方式和投向的描述，正确的是（　　）。",
            "question": "A. 募集方式为非公开募集或基金投向主要为非公开交易的私人股权，二者满足其一即可\nB. 募集方式可公开募集或非公开募集，基金投向可主要为非公开交易的私人股权或公开市场交易的股权\nC. 募集方式仅可非公开募集，基金投向主要为未上市公司的股权和已上市企业的非公开交易股权\nD. 募集方式可公开募集或非公开募集，基金投向主要为非公开交易的私人股权即可",
            "answer": "C",
            "explain": "本题考查资金募集与出资安排。"
        },
        {
            "title": "股权投资基金的服务机构主要包括（　　）。",
            "questions": "I. 基金份额登记机构<br>II. 基金销售机构<br>III. 律师事务所<br>IV. 会计师事务所",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查股权投资基金市场服务机构。"
        },
        {
            "title": "下列非法吸收公众存款行为中，应当依法追究刑事责任的是（　　）。",
            "question": "A. 个人非法吸收或者变相吸收公众存款，数额在10万元以上的\nB. 单位非法吸收或者变相吸收公众存款，数额在100万元以上的\nC. 个人非法吸收或者变相吸收公众存款对象20人以上的\nD. 单位非法吸收或者变相吸收公众存款对象100人以上的",
            "answer": "B",
            "explain": "本题考查非法吸收公众存款罪。"
        },
        {
            "title": "股权回购的基本运作程序通常由（　　）构成。",
            "questions": "I. 发起<br>II. 协商<br>III. 执行<br>IV. 变更登记",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. I、III、IV\nD. I、III",
            "answer": "A",
            "explain": "本题考查回购的一般流程。"
        },
        {
            "title": "股权投资基金管理人、托管人及相关服务机构违反法律法规时，中国证监会及其派出机构可以采取行政监管措施、行政处罚等处理方式。以下处理方式中情节最为严重的是（　　）。",
            "question": "A. 移送司法机关\nB. 警告\nC. 没收违法所得和没收非法财物\nD. 责令改正",
            "answer": "A",
            "explain": "本题考查政府管理的形式与手段。"
        },
        {
            "title": "关于境外直接上市，以下表述正确的是（　　）。",
            "question": "A. 基于相对复杂的公司架构和国资股东情况我国大型国有企业通常不适用于境外直接上市\nB. 境外直接上市是指境内公司将境内资产/权益转移至境外注册的特殊目的公司，以特殊目的公司的名义直接申请境外交易所上市交易\nC. 企业选择境外直接上市，须直接向当地证券交易所申请上市，无需经过中国证监会审批\nD. 境外直接上市的优点包括提升企业国际知名度和影响力，节省信息传递成本，可获得外汇资金等",
            "answer": "D",
            "explain": "本题考查上市转让退出。"
        }, {
            "title": "保护性条款的实施主体和实施方向体现了该条款的独特性在于（　　）。",
            "question": "A. 少数股东同意即可通过特定事项\nB. 多数股东同意即可通过特定事项\nC. 多数股东反对即可终结特定事项\nD. 少数股东反对即可终结特定事项",
            "answer": "D",
            "explain": "本题考查投资协议主要条款。"
        },
        {
            "title": "通过投资于多只股权投资基金，母基金的投资得以在地域、行业、投资风格等方面实现多样性，这一特点体现了股权投资母基金的作用是（　　）。",
            "question": "A. 分散风险\nB. 专业管理\nC. 投资机会\nD. 规模优势",
            "answer": "A",
            "explain": "本题考查股权投资母基金。"
        },
        {
            "title": "下列选项属于增值税的征税范围的是（　　）。",
            "question": "A. 项目上市后通过二级市场退出的收入\nB. 通过并购或回购等非上市股权转让方式退出的项目收入\nC. 股息收入\nD. 分红收入",
            "answer": "A",
            "explain": "本题考查股权投资基金的基本税负。"
        },
        {
            "title": "股权投资基金的收益分配，主要在（　　）之间进行。",
            "question": "A. 投资者与第三方服务机构\nB. 投资者和托管人\nC. 投资者与管理人\nD. 管理人和托管人",
            "answer": "C",
            "explain": "本题考查股权投资基金运作的关键要素。"
        },
        {
            "title": "基金管理人通常需要在（　　）内完成基金的全部投资。",
            "question": "A. 募集期\nB. 退出期\nC. 投资期\nD. 管理期",
            "answer": "C",
            "explain": "本题考查股权投资基金运作流程。"
        },
        {
            "title": "合伙型基金的有限合伙人不得以（　　）出资。",
            "question": "A. 货币\nB. 劳务\nC. 土地使用权\nD. 知识产权",
            "answer": "B",
            "explain": "本题考查资金募集与出资安排。"
        },
        {
            "title": "国外股权投资基金的募集对象不包括（　　）。",
            "question": "A. 养老基金\nB. 大型企业\nC. 社会保障基金\nD. 大学基金会",
            "answer": "C",
            "explain": "本题考查投资者的主要类型。"
        },
        {
            "title": "下列关于信托（契约）型股权投资基金的份额登记事项，表述错误的是（　　）。",
            "question": "A. 基金份额独立于基金份额登记机构的自有财产\nB. 基金份额登记机构应当确保基金销售结算资金、基金份额的安全、独立\nC. 基金管理人可以委托基金服务机构代为办理基金的份额登记事项\nD. 基金管理人委托基金服务机构办理份额登记事宜的，基金管理人可以免除相应的份额登记职责",
            "answer": "D",
            "explain": "本题考查信托（契约）型股权投资基金的登记。"
        }, {
            "title": "股权投资基金项目退出的意义主要有（　　）。",
            "questions": "I. 实现投资收益,控制风险<br>II. 促进投资循环,保持资金流动性<br>III. 评价投资活动,体现投资价值",
            "question": "A. I、II\nB. I、III\nC. II、III\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查项目退出的意义。"
        },
        {
            "title": "基金的控制活动是根据风险评估结果，采用相应的控制措施，将风险控制在可承受范围之内，下列说法正确的是（　　）。",
            "question": "A. 基金资产与管理人自有资产,不同基金的资产和其他委托资产无需实行独立运作与分别核算\nB. 基金管理人应当建立科学、严格的岗位分离制度，明确划分各岗位职责\nC. 基金会计和管理人财务核算会计等重要岗位可以有人员的重要,重要业务部门和岗位应当进行物理隔离\nD. 控制活动是实施内部控制的基础",
            "answer": "B",
            "explain": "本题考查管理人内部控制的要素构成。"
        },
        {
            "title": "我国的股权投资基金行业获得了长足的发展，主要体现在（　　）。",
            "questions": "I. 市场规模增长迅速，当前我国已成为全球第二大股权投资市场<br>II. 市场主体丰富,行业从发展初期阶段的政府和国有企业主导逐步转变为市场化主体主导<br>III. 成为仅次于银行贷款和IPO的重要融资手段<br>IV. 有力地促进了创新创业和经济结构转型升级",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、II、II、IV",
            "answer": "B",
            "explain": "本题考查我国股权投资基金行业发展现状。"
        },
        {
            "title": "设立外商投资创业投资企业，应至少拥有一个“必备投资者”，其应同时满足的条件包括（　　）。",
            "questions": "I. 以创业投资为主营业务<br>II. 在申请前3年其管理的资本累计不低于1亿美元，且其中至少5000万美元已经用于进行创业投资<br>III. 拥有2名以上具有2年以上创业投资从业经验的专业管理人员<br>IV. 公司制创投企业的必备投资者,对创投企业的认缴出资及实际出资分别不低于投资者认缴出资总额及实际出资总额的30%",
            "question": "A. I、II\nB. I、III、IV\nC. I、II、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查对外商投资创业投资企业的管理。"
        },
        {
            "title": "某股权投资基金与目标公司在投资协议中约定“任何一方在未经对方同意的情况下不得披露其条款包含的内容，以及尽职调查的内容”，以上内容属于（　　）。",
            "question": "A. 保密条款\nB. 排他性条款\nC. 保护性条款\nD. 优先认购权条款",
            "answer": "A",
            "explain": "本题考查保密条款的内容。"
        },
        {
            "title": "关于股权投资母基金的业务，下列表述正确的是（　　）。",
            "questions": "I. 母基金开展直接投资业务时，一般扮演镜头角色，与其所投资的股权投资基金联合投资<br>II. 在直接投资业务中，母基金通常侧重于投资其所投资的股权投资基金资产组合中的企业<br>III. 母基金直接对非公开发行的企业股权进行投资后，一般由其所投资的股权投资基金的管理人来管理这项投资<br>IV. 在实际操作中，母基金的联合投资项目往往由其自行管理",
            "question": "A. II、III\nB. I、II、III\nC. II、III、IV\nD. III、IV",
            "answer": "A",
            "explain": "本题考查股权投资母基金的直接投资业务。"
        }, {
            "title": "下列选项中，符合基金管理人专业化经营原则的是（　　）。",
            "questions": "I. 某股权投资基金管理人主营股权投资基金管理业务，兼营小额理财及担保业务<br>II. 某基金管理人登记为“私募股权、创业投资基金管理人”后，同时管理股权投资基金和证券投资基金<br>III. 某股权投资基金管理人名称和经营范围中包含“资产管理”的字样<br>IV. 某基金管理机构有经营多类基金管理业务的实际长期展业需要，设立满足专业化管理要求的2个独立经营实体，分别申请登记成为“私募证券投资基金管理人”、“私募股权、创业投资基金管理人”",
            "question": "A. I、III\nB. III、IV\nC. I、II\nD. II、IV",
            "answer": "B",
            "explain": "本题考查专业化经营原则。"
        },
        {
            "title": "拟融资企业X关于其B轮融资与股权投资基金Y进行洽谈，双方已经签署保密协议，X企业的下述哪项行为可能违反了约定的保密义务（　　）。",
            "question": "A. 创始人向企业重要股东沟通关于待签署投资协议的意见\nB. 创始人向其一位股权投资基金行业的好友私下征求关于投资协议的意见\nC. 将Y基金主页上介绍的尽职调查流程转述给企业的A轮投资人\nD. 经Y基金条件允许，将Y对X的估值建议告知企业的重要商业伙伴",
            "answer": "B",
            "explain": "本题考查保密条款。"
        },
        {
            "title": "设立外商创业投资企业，至少（　　）个投资者符合必备投资者的要求。",
            "question": "A. 一\nB. 二\nC. 三\nD. 五",
            "answer": "A",
            "explain": "本题考查对外商投资创业投资企业的管理。"
        },
        {
            "title": "A股权投资基金对B公司投资后持股比例为40%，公司创始人的持股比例为60%。现公司创始人计划以每股10元的价格向第三方出售其持有的20000股股票，下列表述正确的是（　　）。",
            "question": "A. 如果A基金选择行使随售权，则可以用每股10元的价格向第三方出售8000股，创始股东可同时出售12000股\nB. 如果A基金选择行使随售权，则可以用每股10元的价格向第三方出售20000股，创始股东将无法出售任何股票\nC. 如果A基金选择行使随售权，则可以用每股10元的价格向第三方出售10000股，创始股东可同时出售10000股\nD. 如果A基金同时拥有第一拒绝权和随售权，通常先选择行使指售权再行使第一拒绝权",
            "answer": "A",
            "explain": "本题考查随售权条款。"
        },
        {
            "title": "关于自由现金流折现模型，以下表述错误的是（　　）。",
            "question": "A. 自由现金流折现模型有助于发现目标公司价值的核心驱动因素，但受市场短期变化和非经济因素的影响较小\nB. 股权自由现金流是可以自由分配给股权拥有者的最大现金流\nC. 企业自由现金流是在公司保持正常运营的情况下，可以向包括股权拥有者在内的所有者分配股利\nD. 企业自由现金流折现模型得到的是企业价值，可以通过价值等式推出股权价值",
            "answer": "C",
            "explain": "本题考查自由现金流估值法的优点和不足。"
        },
        {
            "title": "2017年1月1日，某股权投资基金管理人在对某项目公司进行尽职调查过程中，了解到该项目公司2016年的企业自由现金流为500万元。公司的目标资本结构为负债和权益比为0.25:1;现有负债的市场价值为1120万元;股权要求收益率为16%。税前债务成本为8%。所得税税率为25%。经测算D公司未来两年的自由现金流增长率分别为10%和5%，且以后长期自由现金流增长率稳定在5%。",
            "questions": "(1) 采用企业自由现金流折现模型估值时，折现率为（　　）。",
            "question": "A. 8%\nB. 12%\nC. 14%\nD. 9%",
            "answer": "C",
            "explain": "本题考查企业自由现金流折现模型估值。"
        }, {
            "title": "2017年1月1日，某股权投资基金管理人在对某项目公司进行尽职调查过程中，了解到该项目公司2016年的企业自由现金流为500万元。公司资本结构为负债和权益比为0.25:1；现有负债的市场价值为1120万元；股权要求收益率为16%，税前债务成本为8%，所得税率为25%。预测未来两年的自由现金流增长率分别为10%和5%，且以后长期自由现金流增长率稳定在5%。根据前述财务数据，计算可得项目公司的股权价值为（　　）。",
            "question": "A. 4436万元\nB. 6111万元\nC. 4991万元\nD. 5556万元",
            "answer": "C",
            "explain": "本题考查企业自由现金流折现模型估值。FCFF=500×(1+10%)=550;企业价值=FCFF+(WACC-增长率(长期))=550+(14%-5%)×6111万元，股权价值=6111-1120=49万元)"
        },
        {
            "title": "2017年1月1日，某股权投资基金管理人在对某项目公司进行尽职调查过程中，了解到该项目公司2016年的企业自由现金流为500万元，资本结构为负债和权益比为0.25:1;现有负债的市场价值为1120万元;股权要求收益率为16%，税前债务成本为8%，所得税率为25%，未来两年的自由现金流增长率分别为10%和5%，且以后长期自由现金流增长率稳定在5%。上述公司估值水平下，假使目标资本结构不变，未来还可以增加的负债金额为（　　）。",
            "question": "A. 102万元\nB. 269万元\nC. 408万元\nD. 0万元",
            "answer": "A",
            "explain": "本题考查企业自由现金流折现模型估值。计算未来负债:已知公司的目标资本结构为负债和权益比为0.25:1，则股权价值=未来负债×4，企业价值=股权价值+未来负债×4+未来负债=未来负债×5，根据题意，企业价值为6111万元，未来负债=6111+5=1222.2（万元）;"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/smgq-3.js